/**
 * 爱微圈导航 · 分类 / 网站库 / 待办 / 便签
 * 本文件是运行时源（唯一真源）—— 由 tools/split_appjs.py 从 assets/js/app.js 一次性
 * 拆分而来，此后各模块独立维护。**改前端逻辑就改这里**，改完执行 `bash build.sh`
 * 打包成 assets/js/app.min.js（index.php 自动优先引用 .min 产物）。
 * assets/js/app.js 只是拆分时的原始素材，运行时不再加载，勿改。
 */

import { applyWeather, greeting, loadDailyContent, loadWeather, renderClockGreet, renderWeatherPop, tickClock, toggleWeatherPop, weatherGeolocate } from './clock.js';
import { $, $$, API, API_TIMEOUT_MS, CACHE_KEY_LEGACY, DEFAULT_SETTINGS, apiGet, apiPost, bootData, cacheKey, debounce, esc, escAttr, fetchWithTimeout, randomColor, safeUrl, shouldAnimate, state, toast } from './core.js';
import { showContextMenu, showEditModal, showFolderModal } from './edit.js';
import { BUILTIN_ACTIONS, init } from './main.js';
import { closeModal, createCloudBackup, loadBackupListInto, modalConfirm, openModal, runDataRepair, setupDataButtons, showBackupList, showModalError, showQrSync } from './modal.js';
import { ONBOARDING_STEPS, closeOnboarding, maybeShowOnboarding, nextOnbStep, renderOnbStep, showOnboarding } from './onboarding.js';
import { batchDelete, batchMoveToPage, enforcePageCapacity, getPageCapacity, goNextPage, goPrevPage, initBatchToolbar, loadShortcuts, loadShortcutsRaw, prefetchAdjacentPages, prefetchPage, renderPages, shiftPagesAfterRemoval, switchPage, toggleOrganizeMode, updateBatchToolbar, updatePageArrows } from './pages.js';
import { _readIconStore, _reduceMotion, _saveIconStore, _scFp, cardRenderFp, currentGrid, faviconOf, flipMove, getGridCols, gridRenderFp, persistGridReorder, preconnectUrl, renderCardView, renderCardViewAll, renderIcon, renderShortcuts, renderSkeleton, waitTransition } from './render.js';
import { TAB_TARGETS, bindEngineIconFallback, currentEngine, engineBadgeHtml, engineFamily, fetchSuggestions, handleSearch, hideSuggestions, openTarget, renderEngineBadge, renderEngineDropdown, showEngineAddModal } from './search.js';
import { applySettings, bindSettingsUI, loadSettings, scheduleSave } from './settings.js';
import { bindDonateCard, bindShareCard, detectPayApp, fmtDonateTime, loadDonateRank, renderDonateRank, shareQrSrc, shareTargetUrl, shareTextDesc, shareTextTitle, showAboutModal, showContactModal, showDonateModal, showFeedbackModal, showPrivacyModal, showShareModal, showTermsModal } from './share.js';
import { closeDrawers, closeSidebar, doLogout, formatTime, loadUserCategories, openDrawer, openSidebar, renderProfile, resetDataView, showAccountModal, showAuthModal, showCategoryMgr, showCustomAddModal, showDeleteAccountModal, showEmailChangeModal, showForgotPasswordModal, showPhoneBindModal, showQuickAddModal, showSyncChoiceModal, switchSidebarTab } from './sidebar.js';
import { CACHE_TTL, CATEGORY_ENGINE_MAP, applySearchTabUI, cacheState, disableNotifications, enableNotifications, mapCategoryToEngine, notifyEnabled, restoreCache, setNotifyEnabled, showNotification, submitSiteForReview, syncEnabled, toggleSync, trackVisit } from './sync.js';
import { SWATCH_COLORS, showWallpaperModal } from './wallpaper.js';

export const CAT_ICONS = {
    fire: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"/></svg>',
    link: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"/></svg>',
    app: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/></svg>',
    news: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H4v-2h5v2zm0-4H4v-2h5v2zm0-4H4V7h5v2zm11 8h-7V7h7v10z"/></svg>',
    music: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/></svg>',
    image: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/></svg>',
    shopping: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/></svg>',
    social: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"/></svg>',
    sports: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>',
    lifestyle: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>',
    game: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M21.58 16.09l-1.09-7.66C20.21 6.46 18.52 5 16.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66C2.2 17.63 3.39 19 4.94 19c.68 0 1.32-.27 1.8-.75L9 16h6l2.25 2.25c.48.48 1.13.75 1.8.75 1.56 0 2.75-1.37 2.53-2.91zM11 11H9v2H8v-2H6v-1h2V8h1v2h2v1zm4-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/></svg>',
    edu: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/></svg>',
    tech: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/></svg>'
};

export async function loadCategories() {
    state.categories = await apiGet(API.websites + '?action=categories');
    renderCategories();
}

export function renderCategories() {
    const list = $('#categoryList');
    const hotIcon = CAT_ICONS.fire;
    list.innerHTML = `<div class="category-item ${state.currentCat === 0 ? 'active' : ''}" data-cat="0"><span class="c-ico">${hotIcon}</span><span>热门</span></div>` +
        state.categories.map(c => `<div class="category-item ${state.currentCat === c.id ? 'active' : ''}" data-cat="${c.id}"><span class="c-ico">${CAT_ICONS[c.icon] || CAT_ICONS.link}</span><span>${esc(c.name)}</span></div>`).join('');
    $$('.category-item', list).forEach(el => {
        el.onclick = () => { state.currentCat = +el.dataset.cat; renderCategories(); loadWebsites(); };
    });
}
/* ---------- 网站库图标地址生成 ---------- */

export function websiteIconUrls(w) {
    let iconUrl = '';
    if (w.icon_url && !w.icon_url.includes('google.com/s2/favicons')) {
        iconUrl = w.icon_url;
    } else if (w.url) {
        iconUrl = faviconOf(w.url);
    }
    let fallbackUrl = '';
    try {
        const u = new URL(/^https?:/i.test(w.url) ? w.url : 'https://' + w.url);
        fallbackUrl = '/api/icon_proxy.php?url=' + encodeURIComponent('https://icons.duckduckgo.com/ip3/' + u.host + '.ico');
    } catch (e) {}
    const iconText = esc(w.icon_text || (w.name || '?').charAt(0));
    return { iconUrl, fallbackUrl, iconText };
}

/* ---------- 渲染网站库列表（图标懒加载占位） ---------- */

export function renderWebsiteList(sites, list) {
    const addedUrls = new Set((state.shortcuts || []).map(s => s.url));
    if (!sites.length) {
        list.innerHTML = '<div class="website-empty">' + (state.site.empty_websites || '暂无网站') + '</div>';
        return;
    }
    list.innerHTML = sites.map((w, i) => {
        const { iconUrl, fallbackUrl, iconText } = websiteIconUrls(w);
        const isAdded = addedUrls.has(w.url);
        return `
        <div class="website-card ${isAdded ? 'added' : ''}" data-i="${i}">
            <div class="w-icon w-icon-lazy"
                 style="background:${escAttr(w.icon_color || '#5B8DD4')}"
                 data-icon-src="${escAttr(iconUrl)}"
                 data-icon-fallback="${escAttr(fallbackUrl)}"
                 data-fallback-text="${escAttr(iconText)}">${iconText}</div>
            <div class="w-info"><div class="w-name">${esc(w.name)}</div><div class="w-desc">${esc(w.description || '')}</div></div>
            <div class="w-globe" title="访问网站"><svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg></div>
            <div class="w-add" title="${isAdded ? '已添加' : '添加'}">${isAdded ? '✓' : '＋'}</div>
        </div>`;
    }).join('');

    $$('.website-card', list).forEach(el => {
        const w = sites[+el.dataset.i];
        el.querySelector('.w-globe').onclick = (ev) => {
            ev.stopPropagation();
            window.open(w.url, '_blank', 'noopener');
        };
        el.onclick = async () => {
            if (el.classList.contains('added')) return;
            try {
                await apiPost(API.shortcuts + '?action=create', {
                    name: w.name, url: w.url, description: w.description || '',
                    category: w.category || '常用推荐',
                    icon_type: w.icon_type || 'color',
                    icon_color: w.icon_color || '#5B8DD4', icon_text: w.icon_text || '',
                    /* 原先硬编码 icon_url:''，导致从网站库添加的快捷方式永远拿不到真实图标，
                     * 只能显示文字兜底。改为继承库里的图标地址，没有则回落到 favicon 代理。 */
                    icon_url: w.icon_url || faviconOf(w.url),
                    page: state.currentPage,
                });
                el.classList.add('added');
                el.querySelector('.w-add').innerHTML = '✓';
                el.querySelector('.w-add').title = '已添加';
                toast(`已添加「${w.name}」`, 'success');
                loadShortcuts();
            } catch (e) { toast(e.message, 'error'); }
        };
    });

    observeWebsiteIcons(list);
}

/* ---------- 网站库图标懒加载 ---------- */

export function loadWebsiteIcon(el) {
    if (!el || !el.classList.contains('w-icon-lazy')) return;
    const src = el.dataset.iconSrc;
    const fallbackSrc = el.dataset.iconFallback;
    const fallbackText = el.dataset.fallbackText || '?';
    el.classList.remove('w-icon-lazy');
    if (!src) { el.textContent = fallbackText; return; }
    /* 这里不要用 img.loading='lazy'：
     * 图片是先创建、等 onload 后才 appendChild 的（避免闪一下占位文字），
     * 而原生 lazy 对「尚未插入文档」的 img 可能永远不触发加载 → 图标一直是文字兜底。
     * 懒加载交给下面的 IntersectionObserver 控制即可，二者重复只会互相干扰。 */
    const img = document.createElement('img');
    img.className = 'w-icon-img'; img.alt = ''; img.decoding = 'async'; img.referrerPolicy = 'no-referrer';
    img.onload = () => {
        el.textContent = '';
        el.style.background = 'rgba(255,255,255,0.92)';
        el.appendChild(img);
        requestAnimationFrame(() => img.classList.add('loaded'));
    };
    img.onerror = () => {
        if (fallbackSrc && img.src !== fallbackSrc) {
            img.onerror = () => { el.textContent = fallbackText; };
            img.src = fallbackSrc;
            return;
        }
        el.textContent = fallbackText;
    };
    img.src = src;
}


export function observeWebsiteIcons(list) {
    if (!window.IntersectionObserver) {
        $$('.w-icon-lazy', list).forEach(el => loadWebsiteIcon(el));
        return;
    }
    if (!window._websiteIconObs) {
        window._websiteIconObs = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    loadWebsiteIcon(entry.target);
                    window._websiteIconObs.unobserve(entry.target);
                }
            });
        }, { root: list, rootMargin: '60px' });
    }
    $$('.w-icon-lazy', list).forEach(el => window._websiteIconObs.observe(el));
    /* 兜底：侧栏刚展开、容器尺寸还是 0、或 observer 因故未回调时，图标会一直停在文字占位。
     * 延迟强推一次，保证最终一定能尝试加载真实图标（loadWebsiteIcon 幂等，已加载的会被跳过）。 */
    clearTimeout(window._websiteIconFallbackTimer);
    window._websiteIconFallbackTimer = setTimeout(() => {
        $$('.w-icon-lazy', list).forEach(el => loadWebsiteIcon(el));
    }, 1200);
}

/* ---------- 预加载相邻分类网站库 ---------- */

export function preloadAdjacentCategories(currentCat, q) {
    if (q || !state.categories.length) return;
    const idx = state.categories.findIndex(c => c.id === currentCat);
    const ids = [];
    if (idx > 0) ids.push(state.categories[idx - 1].id);
    if (idx >= 0 && idx < state.categories.length - 1) ids.push(state.categories[idx + 1].id);
    ids.forEach(id => {
        const key = 'c:' + id;
        if (state.websiteCache[key]) return;
        fetch(API.websites + '?action=websites&cat=' + id, { credentials: 'same-origin' })
            .then(r => r.ok ? r.json() : Promise.reject())
            .then(sites => { state.websiteCache[key] = { sites, ts: Date.now() }; })
            .catch(() => {});
    });
}

/* ---------- 加载网站库（带缓存 / 取消 / 懒加载） ---------- */

export async function loadWebsites(force = false) {
    const list = $('#websiteList');
    const q = $('#addSearchInput') ? $('#addSearchInput').value.trim() : '';
    const cat = state.currentCat;
    const key = q ? 's:' + q : 'c:' + cat;
    const now = Date.now();
    const cacheEntry = state.websiteCache[key];
    const cacheValid = cacheEntry && (now - cacheEntry.ts < 300000) && !force;

    if (cacheValid) {
        renderWebsiteList(cacheEntry.sites, list);
    } else {
        list.innerHTML = '<div class="website-skeleton">加载中…</div>';
    }

    if (state._websiteAbort) {
        state._websiteAbort.abort();
        state._websiteAbort = null;
    }
    const ctrl = new AbortController();
    state._websiteAbort = ctrl;

    let url = API.websites + '?action=websites';
    if (q) url += '&search=' + encodeURIComponent(q);
    else if (cat) url += '&cat=' + cat;

    try {
        const sites = await apiGet(url, { signal: ctrl.signal });
        state.websiteCache[key] = { sites, ts: now };
        renderWebsiteList(sites, list);
        preloadAdjacentCategories(cat, q);
    } catch (e) {
        if (e && e.name === 'AbortError') return;
        if (cacheEntry && cacheEntry.sites && cacheEntry.sites.length) {
            renderWebsiteList(cacheEntry.sites, list);
            toast('网站库刷新失败，已显示缓存内容', 'error');
        } else {
            list.innerHTML = '<div class="website-empty">加载失败</div>';
        }
    } finally {
        if (state._websiteAbort === ctrl) state._websiteAbort = null;
    }
}

/* ---------- 待办 ---------- */
/* 通用小图标（内联 SVG，随按钮 currentColor 变色） */

export const ICO_CHECK  = '<svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>';

export const ICO_EDIT   = '<svg viewBox="0 0 24 24"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 000-1.41l-2.34-2.34a1 1 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>';

export const ICO_TRASH  = '<svg viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>';

export const ICO_PIN    = '<svg viewBox="0 0 24 24"><path d="M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z"/></svg>';

export const ICO_EXPAND = '<svg viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>';

export const ICO_COPY   = '<svg viewBox="0 0 24 24"><path d="M16 1H4a2 2 0 00-2 2v14h2V3h12V1zm3 4H8a2 2 0 00-2 2v14a2 2 0 002 2h11a2 2 0 002-2V7a2 2 0 00-2-2zm0 16H8V7h11v14z"/></svg>';


export async function loadTodos() {
    try { state.todos = await apiGet(API.todos + '?action=list'); }
    catch (e) { /* 保留现有内容，避免网络抖动清空列表 */ }
    renderTodos();
}

export async function addTodo() {
    const input = $('#todoInput');
    if (!input) return;
    const text = (input.value || '').trim();
    if (!text) { input.focus(); return; }
    try {
        await apiPost(API.todos + '?action=create', { text });
        input.value = '';
        await loadTodos();
        input.focus();
    } catch (err) { toast(err.message, 'error'); }
}

export async function toggleTodo(id) {
    await apiPost(API.todos + '?action=toggle', { id }).catch(() => {});
    await loadTodos();
}
/* 行内编辑：双击文字或点铅笔进入，回车/失焦保存，Esc 取消 */

export function startTodoEdit(id, el) {
    const t = (state.todos || []).find(x => +x.id === +id);
    if (!t) return;
    const span = el.querySelector('.todo-text');
    if (!span || el.querySelector('.todo-edit-input')) return;
    const input = document.createElement('input');
    input.type = 'text'; input.className = 'todo-edit-input';
    input.value = t.text; input.maxLength = 200;
    span.replaceWith(input);
    input.focus(); input.select();
    let closed = false;
    const finish = async (commit) => {
        if (closed) return; closed = true;
        const val = input.value.trim();
        if (commit && val && val !== t.text) {
            try { await apiPost(API.todos + '?action=update', { id: t.id, text: val }); }
            catch (e) { toast(e.message, 'error'); }
        }
        await loadTodos();
    };
    input.onkeydown = (e) => {
        if (e.key === 'Enter') { e.preventDefault(); finish(true); }
        else if (e.key === 'Escape') { e.preventDefault(); finish(false); }
    };
    input.onblur = () => finish(true);
}

export function renderTodos() {
    const list = $('#todoList');
    if (!list) return;
    const all = Array.isArray(state.todos) ? state.todos : [];
    const f = state.todoFilter || 'all';
    const items = f === 'active' ? all.filter(t => !Number(t.done))
                : f === 'done'   ? all.filter(t => Number(t.done))
                : all;

    if (!items.length) {
        const tip = f === 'done' ? '还没有已完成的待办'
                  : f === 'active' ? (all.length ? '待办都清空啦 🎉' : (state.site.empty_todo || '暂无待办，输入内容开始记录 ✍️'))
                  : (state.site.empty_todo || '暂无待办，输入内容开始记录 ✍️');
        list.innerHTML = `<div class="todo-empty">
            <svg class="empty-illu" viewBox="0 0 120 92">
                <rect x="30" y="14" width="60" height="68" rx="10" fill="none" stroke="currentColor" stroke-width="2" opacity=".35"/>
                <rect x="52" y="7" width="16" height="13" rx="4" fill="none" stroke="currentColor" stroke-width="2" opacity=".35"/>
                <path d="M44 38h32M44 50h32M44 62h20" stroke="currentColor" stroke-width="2" stroke-linecap="round" opacity=".25"/>
            </svg>
            <div class="empty-text">${esc(tip)}</div>
        </div>`;
    } else {
        list.innerHTML = items.map(t => `
            <div class="todo-item${Number(t.done) ? ' done' : ''}" data-id="${t.id}">
                <button class="todo-check" title="${Number(t.done) ? '标记为未完成' : '标记为已完成'}" aria-pressed="${Number(t.done) ? 'true' : 'false'}">${ICO_CHECK}</button>
                <span class="todo-text${Number(t.done) ? ' done' : ''}" title="双击可编辑">${esc(t.text)}</span>
                <div class="todo-ops">
                    <button class="todo-edit" title="编辑">${ICO_EDIT}</button>
                    <button class="todo-del" title="删除">${ICO_TRASH}</button>
                </div>
            </div>`).join('');

        $$('.todo-item', list).forEach(el => {
            const t = all.find(x => +x.id === +el.dataset.id);
            if (!t) return;
            el.querySelector('.todo-check').onclick = () => toggleTodo(t.id);
            el.querySelector('.todo-text').ondblclick = () => startTodoEdit(t.id, el);
            el.querySelector('.todo-edit').onclick = () => startTodoEdit(t.id, el);
            el.querySelector('.todo-del').onclick = async () => {
                await apiPost(API.todos + '?action=delete', { id: t.id }).catch(() => {});
                await loadTodos();
            };
        });
    }

    /* 统计与进度 */
    const done = all.filter(t => Number(t.done)).length;
    const undone = all.length - done;
    const pct = all.length ? Math.round(done / all.length * 100) : 0;
    const stats = $('#todoStats'), pctEl = $('#todoPct'), bar = $('#todoProgressBar'), wrap = $('#todoProgress');
    if (stats) stats.textContent = all.length ? `${undone} 项待办 · ${done} 已完成` : '';
    if (pctEl) pctEl.textContent = all.length ? pct + '%' : '';
    if (bar) bar.style.width = pct + '%';
    if (wrap) wrap.style.display = all.length ? '' : 'none';
    const clearBtn = $('#todoClearDone');
    if (clearBtn) clearBtn.classList.toggle('is-disabled', done === 0);

    const badge = $('#todoBadge');
    if (badge) {
        if (state.settings.show_todo_count === '1' && undone > 0) {
            badge.style.display = 'flex';
            badge.textContent = undone > 99 ? '99+' : undone;
        } else badge.style.display = 'none';
    }
}

/* ---------- 便签 ---------- */

export const NOTE_COLORS = ['#fef3c7', '#dcfce7', '#dbeafe', '#fce7f3', '#ede9fe', '#ffedd5'];
/* 相对时间：刚刚 / x 分钟前 / x 小时前 / 昨天 / M月D日 */

export function relTime(ts) {
    if (!ts) return '';
    const d = new Date(String(ts).replace(' ', 'T'));
    if (isNaN(d.getTime())) return '';
    const diff = Date.now() - d.getTime();
    if (diff < 60 * 1000) return '刚刚';
    if (diff < 3600 * 1000) return Math.floor(diff / 60000) + ' 分钟前';
    if (diff < 86400 * 1000) return Math.floor(diff / 3600000) + ' 小时前';
    if (diff < 2 * 86400 * 1000) return '昨天';
    return (d.getMonth() + 1) + '月' + d.getDate() + '日';
}

export async function loadNotes() {
    try { state.notes = await apiGet(API.notes + '?action=list'); }
    catch (e) { /* 保留现有内容，避免网络抖动清空 */ }
    renderNotes();
}

export async function addNote() {
    try {
        await apiPost(API.notes + '?action=create', {
            content: '新便签',
            color: NOTE_COLORS[(state.notes || []).length % NOTE_COLORS.length]
        });
        await loadNotes();
        const ta = $('#notesList .note-card .note-content');
        if (ta) { ta.focus(); ta.select(); }
    } catch (e) { toast(e.message, 'error'); }
}
/* 放大编辑：网格里的小 textarea 不好写长内容，弹出大编辑框 */

export function openNoteEditor(id) {
    const n = (state.notes || []).find(x => +x.id === +id);
    if (!n) return;
    openModal(`
        <div class="modal-title">编辑便签</div>
        <textarea class="form-input note-editor" id="noteEditorTa" placeholder="记录点什么…">${esc(n.content || '')}</textarea>
        <div class="modal-actions" style="margin-top:14px">
            <button class="btn btn-light" data-close-modal>取消</button>
            <button class="btn btn-primary" id="noteEditorSave">保存</button>
        </div>`);
    const ta = $('#noteEditorTa');
    if (ta) { ta.focus(); ta.setSelectionRange(ta.value.length, ta.value.length); }
    $('#noteEditorSave').onclick = async () => {
        try {
            await apiPost(API.notes + '?action=update', { id: n.id, content: ta.value });
            n.content = ta.value;
            closeModal();
            await loadNotes();
        } catch (e) { toast(e.message, 'error'); }
    };
}

export async function copyNote(id) {
    const n = (state.notes || []).find(x => +x.id === +id);
    if (!n) return;
    const text = n.content || '';
    try {
        if (navigator.clipboard && navigator.clipboard.writeText) await navigator.clipboard.writeText(text);
        else throw new Error('no clipboard');
        toast('便签内容已复制', 'success');
    } catch (e) { toast(text, 'info'); }
}

export function renderNotes() {
    const list = $('#notesList');
    if (!list) return;
    const kw = (state.noteFilter || '').trim().toLowerCase();
    const notes = (state.notes || []).filter(n => !kw || String(n.content || '').toLowerCase().includes(kw));

    const addCard = '<div class="note-add-card" id="noteAddCard">＋ 新便签</div>';
    if (!notes.length) {
        const tip = kw ? '没有匹配的便签' : '还没有便签，点击下面的卡片新建一条 📝';
        list.innerHTML = `<div class="notes-empty">
            <svg class="empty-illu" viewBox="0 0 120 92">
                <path d="M34 12h52l14 14v54a6 6 0 01-6 6H40a6 6 0 01-6-6V18a6 6 0 016-6z" fill="none" stroke="currentColor" stroke-width="2" opacity=".35"/>
                <path d="M86 12v14h14" fill="none" stroke="currentColor" stroke-width="2" opacity=".35"/>
                <path d="M50 46h34M50 58h34M50 70h22" stroke="currentColor" stroke-width="2" stroke-linecap="round" opacity=".25"/>
            </svg>
            <div class="empty-text">${esc(tip)}</div>
        </div>` + addCard;
    } else {
        list.innerHTML = notes.map(n => {
            const pinned = Number(n.pinned) === 1;
            const color = n.color || '#fef3c7';
            return `
        <div class="note-card${pinned ? ' pinned' : ''}" data-id="${n.id}" style="background:${escAttr(color)}">
            <div class="note-ops">
                <button class="note-op pin${pinned ? ' on' : ''}" title="${pinned ? '取消置顶' : '置顶'}">${ICO_PIN}</button>
                <button class="note-op expand" title="放大编辑">${ICO_EXPAND}</button>
                <button class="note-op copy" title="复制内容">${ICO_COPY}</button>
                <button class="note-op del" title="删除">${ICO_TRASH}</button>
            </div>
            <textarea class="note-content" placeholder="记录点什么…">${esc(n.content || '')}</textarea>
            <div class="note-foot">
                <div class="note-colors">${NOTE_COLORS.map(c =>
                    `<span class="note-swatch${c === color ? ' active' : ''}" data-c="${c}" style="background:${c}"></span>`).join('')}</div>
                <span class="note-meta">
                    <span class="note-count">${(n.content || '').length} 字</span>
                    <span class="note-time">${esc(relTime(n.updated_at))}</span>
                </span>
            </div>
        </div>`;
        }).join('') + addCard;

        $$('.note-card', list).forEach(el => {
            const n = (state.notes || []).find(x => +x.id === +el.dataset.id);
            if (!n) return;
            const ta = el.querySelector('.note-content');
            const count = el.querySelector('.note-count');
            const save = debounce(async () => {
                await apiPost(API.notes + '?action=update', { id: n.id, content: ta.value, color: n.color }).catch(() => {});
            }, 600);
            ta.oninput = () => {
                n.content = ta.value;
                if (count) count.textContent = ta.value.length + ' 字';
                save();
            };
            $$('.note-swatch', el).forEach(sw => {
                sw.onclick = async () => {
                    n.color = sw.dataset.c;
                    el.style.background = n.color;
                    $$('.note-swatch', el).forEach(x => x.classList.toggle('active', x === sw));
                    await apiPost(API.notes + '?action=update', { id: n.id, color: n.color }).catch(() => {});
                };
            });
            el.querySelector('.note-op.pin').onclick = async () => {
                n.pinned = Number(n.pinned) ? 0 : 1;
                await apiPost(API.notes + '?action=update', { id: n.id, pinned: n.pinned }).catch(() => {});
                await loadNotes();
            };
            el.querySelector('.note-op.expand').onclick = () => openNoteEditor(n.id);
            el.querySelector('.note-op.copy').onclick = () => copyNote(n.id);
            el.querySelector('.note-op.del').onclick = async () => {
                const ok = await modalConfirm('删除便签', '确认删除这条便签？');
                if (!ok) return;
                await apiPost(API.notes + '?action=delete', { id: n.id }).catch(() => {});
                await loadNotes();
            };
        });
    }
    const addBtn = $('#noteAddCard');
    if (addBtn) addBtn.onclick = addNote;
    const wrap = $('#notesSearchWrap');
    if (wrap) wrap.classList.toggle('has-value', !!kw);
}

/* ---------- 侧栏 / 抽屉 ---------- */

